<template>
    <div class="header">
      <div class="text-center">
        <div class="login-logo pass-rec">
          <h4 class="login-title">{{ $t('Password recovery') }}</h4>
        </div>
        <div class="form-group">
          <label>{{ $t('Please enter you email') }}</label>
          <input type="text" :placeholder="$t('Email')" v-model="recoveryEmail"
                 class="form-control">
        </div>
        <div class="form-group">
          <button class="btn primary-bg d-block w-100" @click="recoverPassword">
            <i class="fa fa-spinner fa-spin" v-if="recoverySpinner"></i>
            <span v-else>
                {{ $t('Recover') }}
              </span>
          </button>
        </div>
        <div class="form-group text-danger" v-if="e.error">{{ e.error }}</div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import URL from "../../assets/js/URL-Parser/js/URLParser";

export default {
    name: "recovery",
    data() {
        return {
            e: {
                error: false,
                errors: {
                    unvalidEmail: this.$t('The provided Email does not exists')
                }
            },
            recoverySpinner: false,
            recoveryEmail: null,
        };
    },
    computed: {
        ...mapState({
            trainerId: state => state.trainerVisit,
            trainerList: state => state.frontPage.trainerSearch.trainerList
        })
    },
    mounted() {
        if (URL.get("affiliateLink")) {
            let exp = new Date();
            exp.setDate(exp.getDate() + 2);
            let affiliate = {
                link: URL.get("affiliateLink"),
                expiration: exp
            };
            localStorage.setItem("affiliate", JSON.stringify(affiliate));
        }
        if (URL.get('passwordToken')) {
            // $('#resetPassModal').modal('show');
        }
    },
    methods: {
        toggleLogin() {

        },
        recoverPassword() {
            let vm = this;
            this.recoverySpinner = true;
            axios.post(process.env.api_hostname + '/recoverPassword',
                {
                    email: vm.recoveryEmail,
                    domain: process.env.domain
                }).then(response => {
                    if (response.data.error == 'unvalidEmail') {
                        vm.e.error = vm.e.errors.unvalidEmail;
                    }
                    this.$notify({
                        group: "foo",
                        title: this.$t("Message"),
                        text: this.$t("Check your email for a recovery link!")
                    });
                    vm.recoveryEmail = null;
                    $('#loginModal').modal('hide');
                    vm.showLogin = true;
                    vm.recoverySpinner = false;
                });
        }
    }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/frontpage/Recovery.vue